import { defineStore } from 'pinia'

// 字典值类型
export interface DictValueType {
  value: any
  label: string
  colorType?: string
  cssClass?: string
}

// 字典状态
export interface DictState {
  dictMap: Record<string, DictValueType[]>
  isSetDict: boolean
}

export const useDictStore = defineStore('dict', {
  state: (): DictState => ({
    dictMap: {},
    isSetDict: false
  }),
  
  getters: {
    getDictMap(): Record<string, DictValueType[]> {
      return this.dictMap
    },
    getIsSetDict(): boolean {
      return this.isSetDict
    }
  },
  
  actions: {
    /**
     * 设置字典数据映射
     * Portal 端使用静态字典数据
     */
    async setDictMap() {
      // Portal 端直接使用静态字典数据
      // 不从后端获取，因为 Portal 端的字典数据相对固定
      this.dictMap = getDefaultDictData()
      this.isSetDict = true
    },
    
    /**
     * 根据类型获取字典数据
     */
    async getDictByType(type: string): Promise<DictValueType[]> {
      if (!this.isSetDict) {
        await this.setDictMap()
      }
      return this.dictMap[type] || []
    },
    
    /**
     * 重置字典数据
     */
    async resetDict() {
      await this.setDictMap()
    }
  }
})

/**
 * 默认字典数据（作为后备）
 */
function getDefaultDictData(): Record<string, DictValueType[]> {
  return {
    seal_type: [
      { value: 1, label: '个人印章', colorType: 'primary', cssClass: '' },
      { value: 2, label: '企业印章', colorType: 'success', cssClass: '' }
    ],
    seal_status: [
      { value: 0, label: '正常', colorType: 'success', cssClass: '' },
      { value: 1, label: '停用', colorType: 'danger', cssClass: '' }
    ],
    seal_category: [
      { value: 1, label: '企业公章', colorType: '', cssClass: '' },
      { value: 2, label: '合同章', colorType: '', cssClass: '' },
      { value: 3, label: '财务章', colorType: '', cssClass: '' },
      { value: 4, label: '法人章', colorType: '', cssClass: '' }
    ],
    common_status: [
      { value: 0, label: '正常', colorType: 'success', cssClass: '' },
      { value: 1, label: '禁用', colorType: 'danger', cssClass: '' }
    ]
  }
}
